import { render, staticRenderFns } from "./RiskAssessmentRatingKey.vue?vue&type=template&id=62e7481e&scoped=true&"
import script from "./RiskAssessmentRatingKey.vue?vue&type=script&lang=ts&"
export * from "./RiskAssessmentRatingKey.vue?vue&type=script&lang=ts&"
import style0 from "./RiskAssessmentRatingKey.vue?vue&type=style&index=0&id=62e7481e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7481e",
  null
  
)

export default component.exports